import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface AuthState {
  token: string | null
  isAuthenticated: boolean
  mustChangePassword: boolean
  setToken: (token: string | null) => void
  clearToken: () => void
  setMustChangePassword: (value: boolean) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      isAuthenticated: false,
      mustChangePassword: false,
      setToken: (token: string | null) => {
        if (token) {
          // apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
          set({ token, isAuthenticated: true })
        }
      },
      clearToken: () => {
        // delete apiClient.defaults.headers.common['Authorization']
        set({ token: null, isAuthenticated: false, mustChangePassword: false })
      },
      setMustChangePassword: (value: boolean) => {
        set({ mustChangePassword: value })
      },
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => {
        // 當從 storage 恢復狀態時，重新設置 axios header
        return (state) => {
          if (state?.token) {
            // apiClient.defaults.headers.common['Authorization'] = `Bearer ${state.token}`
          }
        }
      },
    },
  ),
)
